import { Switch } from '@thanx/uikit/switch'
import { Text } from '@thanx/uikit/text'
import { SEGMENT_DETAILS } from 'components/SegmentDetails/constants'
import 'components/SegmentDetails/segmentDetails.scss'
import { buildTranslate } from 'locales'
import { Fields as TargetSegment } from 'models/TargetSegment'
import Tab from 'react-bootstrap-five/Tab'

const t = buildTranslate('segments.details')

interface SegmentSummaryProps {
  segment: TargetSegment
  tabId?: string
}

const SegmentSummary = ({ segment, tabId }: SegmentSummaryProps) => {
  // Check if any of the text attributes are available (the names may change for final implementation)
  const hasCustomerBehaviorText = !!segment.customer_behaviour_text
  const hasAutomationText = !!segment.automation_text
  const hasOneTimeText = !!segment.one_time_text
  const hasAnyAIText =
    hasCustomerBehaviorText || hasAutomationText || hasOneTimeText

  return (
    <Tab.Pane
      eventKey={SEGMENT_DETAILS.TAB_KEYS.SUMMARY}
      className="segment-details__tab-pane"
      role="tabpanel"
      id={
        tabId ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SUMMARY}-panel` : undefined
      }
      aria-labelledby={
        tabId ? `${tabId}-${SEGMENT_DETAILS.TAB_KEYS.SUMMARY}-tab` : undefined
      }
    >
      <Switch
        condition={hasAnyAIText}
        fallback={
          <div>
            <div className="segment-details__section-header">
              <Text.BodyText3
                color="grey90"
                className="segment-details__section-title"
              >
                {t('summary.description_title')}
              </Text.BodyText3>
            </div>
            <Text.BodyText3 color="grey70">
              {segment.description || t('summary.description')}
            </Text.BodyText3>
          </div>
        }
      >
        <Switch condition={hasCustomerBehaviorText}>
          <div className="mb-xl">
            <div className="segment-details__section-header">
              <Text.BodyText3
                color="grey90"
                className="segment-details__section-title"
              >
                {t('summary.customer_behavior')}
              </Text.BodyText3>
            </div>
            <Text.BodyText3 color="grey70">
              {segment.customer_behaviour_text}
            </Text.BodyText3>
          </div>
        </Switch>

        <Switch condition={hasAutomationText}>
          <div className="mb-l">
            <Text.BodyText3
              color="grey90"
              tag="h4"
              className="segment-details__section-title"
            >
              {t('summary.when_used_as_automation_title')}
            </Text.BodyText3>
            <Text.BodyText3 color="grey70">
              {segment.automation_text}
            </Text.BodyText3>
          </div>
        </Switch>

        <Switch condition={hasOneTimeText}>
          <div>
            <Text.BodyText3
              color="grey90"
              tag="h4"
              className="segment-details__section-title"
            >
              {t('summary.when_used_as_one_time_title')}
            </Text.BodyText3>
            <Text.BodyText3 color="grey70">
              {segment.one_time_text}
            </Text.BodyText3>
          </div>
        </Switch>
      </Switch>
    </Tab.Pane>
  )
}

export default SegmentSummary
